import { createAction, props } from '@ngrx/store';
import { Farm } from '../_models/farm';

// Action types
export const loadFarms = createAction('[Farm] Load Farms');
export const loadFarmsSuccess = createAction(
  '[Farm] Load Farms Success',
  props<{ farms: Farm[] }>()
);
export const loadFarmsFailure = createAction('[Farm] Load Farms Failure', props<{ error: any }>());

export const addFarm = createAction('[Farm] Add Farm', props<{ farm: Farm }>());
export const addFarmSuccess = createAction('[Farm] Add Farm Success', props<{ farm: Farm }>());
export const addFarmFailure = createAction('[Farm] Add Farm Failure', props<{ error: any }>());

export const updateFarm = createAction('[Farm] Update Farm', props<{ farm: Farm }>());
export const updateFarmSuccess = createAction(
  '[Farm] Update Farm Success',
  props<{ farm: Farm }>()
);
export const updateFarmFailure = createAction(
  '[Farm] Update Farm Failure',
  props<{ error: any }>()
);

export const deleteFarm = createAction('[Farm] Delete Farm', props<{ id: number }>());
export const deleteFarmSuccess = createAction(
  '[Farm] Delete Farm Success',
  props<{ id: number }>()
);
export const deleteFarmFailure = createAction(
  '[Farm] Delete Farm Failure',
  props<{ error: any }>()
);
